import {
  SET_CASH_BANK,
  SET_CASH_BANK_ACTION_LOADING,
  SET_CASH_BANK_DETAIL,
  SET_CASH_BANK_ERROR,
  SET_CASH_BANK_LOADING,
} from "../../actions/cashBankAction";

const initialState = {
  data: null,
  detail: null,
  loading: false,
  actionLoading: false,
  error: null,
};

const cashBankReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CASH_BANK:
      return { ...state, data: action.data, error: null };
    case SET_CASH_BANK_DETAIL:
      return { ...state, detail: action.data, error: null };
    case SET_CASH_BANK_LOADING:
      return { ...state, loading: action.status };
    case SET_CASH_BANK_ACTION_LOADING:
      return { ...state, actionLoading: action.status };
    case SET_CASH_BANK_ERROR:
      return { ...state, error: action.error, loading: false, actionLoading: false };
    default:
      return state;
  }
};

export default cashBankReducer;
